import React, {useContext} from 'react';
import {observer} from 'mobx-react-lite';
import {StoreContext} from '../base/root-store';
import {
    Button,
    Grid,
    GridColumn,
    Heat,
    Modal,
    ModalCloser,
    ModalContent,
    ModalFooter,
    ModalHeader,
} from '../../../patterns';

export const HeatmapHelpModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).teamResultsStore;

    return (
        <Modal size="small">
            <ModalHeader>
                <h4>{store.label('dashboard.heatmap-help-modal.title')}</h4>
            </ModalHeader>
            <ModalContent>
                <div className="text">
                    <p>{store.label('dashboard.heatmap-help-modal.content')}</p>
                    <Grid justify={['right-xs']}>
                        <GridColumn width={['xs-3']}>
                            <Heat level={1}/>
                        </GridColumn>
                        <GridColumn width={['xs-9']}>
                            {store.label('dashboard.heatmap-help-modal.heat-score-green')}
                        </GridColumn>
                    </Grid>
                    <Grid justify={['right-xs']}>
                        <GridColumn width={['xs-3']}>
                            <Heat level={3}/>
                        </GridColumn>
                        <GridColumn width={['xs-9']}>
                            {store.label('dashboard.heatmap-help-modal.heat-score-red')}
                        </GridColumn>
                    </Grid>
                    <Grid justify={['right-xs']}>
                        <GridColumn width={['xs-3']}>
                            <Heat level={6}/>
                        </GridColumn>
                        <GridColumn width={['xs-9']}>
                            {store.label('dashboard.heatmap-help-modal.heat-score-grey')}
                        </GridColumn>
                    </Grid>
                </div>
                <div className="text">
                    <p className="modal__help-link-label">
                        <a href={'https://moticheck.com/kb/'} target={'_blank'} rel="noreferrer">{store.label('common.help-modal.content-help-text-label')}</a>
                    </p>
                </div>
            </ModalContent>
            <ModalFooter>
                <Grid wrap={['xs']} justify={['center-xs']}>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <ModalCloser>
                            <Button block={true} color="white" text={store.label('common.modal.close')}/>
                        </ModalCloser>
                    </GridColumn>
                </Grid>
            </ModalFooter>
        </Modal>
    );
});
